import React, {useEffect} from "react";
import {Navigate, useLocation} from "react-router-dom";
import {useSession} from "@/hook/useSession";
import {useAccountStore} from "@/store/useAccountStore";
import {LoadingSpinner} from "@/component/view/LoadingSpinner";
import {ErrorMessage} from "@/component/view/ErrorMessage";

export const RequireAuth = (props: any) => {
    const session = useSession();
    const location = useLocation();
    const {clearAccounts, loadAccounts, isLoading, error} = useAccountStore();

    useEffect(() => {
        if (session) {
            void loadAccounts();
        } else {
            clearAccounts();
        }
    }, [session]);

    if (isLoading) {
        return <LoadingSpinner/>;
    }

    if (error) {
        return <ErrorMessage error={error} onRetry={() => loadAccounts()}/>;
    }

    if (session) {
        return props.children;
    } else {
        return <Navigate to="/login" state={{from: location}} replace/>;
    }
};
